'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classnames';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { twMerge } from '@utils/tw-merge';
import { FaqRichText } from './faq-rich-text';
import type { Faq } from './traveler-faqs';
interface FaqAccordionProps {
  faqs: readonly Faq[];
  questionComponent: 'h2' | 'h3';
  defaultOpenSlug?: string;
  className?: string;
}
export function FaqAccordion(t0) {
  const $ = _c(12);
  const {
    faqs,
    questionComponent,
    defaultOpenSlug,
    className
  } = t0;
  const QuestionComponent = questionComponent;
  let t1;
  if ($[0] !== className) {
    t1 = twMerge("flex w-full flex-col gap-6", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== QuestionComponent || $[3] !== defaultOpenSlug || $[4] !== faqs) {
    let t3;
    if ($[6] !== QuestionComponent || $[7] !== defaultOpenSlug) {
      t3 = faq => <Disclosure key={faq.slug} as="div" defaultOpen={faq.slug === defaultOpenSlug} className="rounded-2xl bg-off-white">{t4 => {
          const {
            open
          } = t4;
          return <><QuestionComponent><DisclosureButton className="flex w-full items-center justify-between gap-4 rounded-2xl p-6 text-left text-lg font-bold leading-7 text-primary-main focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-main">{faq.question}<FontAwesomeIcon icon={faChevronDown} className={cx("h-4 w-4 flex-shrink-0 text-primary-main transition-transform duration-300 motion-reduce:transition-none", {
                  "rotate-180": open
                })} aria-hidden="true" /></DisclosureButton></QuestionComponent><DisclosurePanel unmount={false} className="-mt-3 flex flex-col gap-4 px-6 pb-6 text-lg leading-7 text-primary-main">{faq.answer.map(_temp)}</DisclosurePanel></>;
        }}</Disclosure>;
      $[6] = QuestionComponent;
      $[7] = defaultOpenSlug;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = faqs.map(t3);
    $[2] = QuestionComponent;
    $[3] = defaultOpenSlug;
    $[4] = faqs;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
function _temp(paragraph, index) {
  return <p key={index}><FaqRichText paragraph={paragraph} /></p>;
}